/**
 * Searching the settings page: sections by name and by the words people use
 * for them, and the tabs inside sections (so "overtime" finds Time &
 * attendance › Pay rules). Pure, so it is easy to test.
 */
import type { SettingsSectionGroup, SettingsSectionItem } from './SettingsPageFrame';

export interface SectionSearchHit {
  section: SettingsSectionItem;
  /** Set when the match was a tab inside the section. */
  tab?: { id: string; label: string };
}

const matches = (q: string, ...texts: Array<string | undefined>) => texts.some((t) => !!t && t.toLowerCase().includes(q));

/** Every section and tab whose name or keywords contain the query, in page order; sections before their tabs. */
export function searchSections(groups: SettingsSectionGroup[], query: string): SectionSearchHit[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const hits: SectionSearchHit[] = [];
  for (const g of groups) {
    for (const s of g.items) {
      if (matches(q, s.label, ...(s.keywords ?? []))) hits.push({ section: s });
      for (const t of s.tabs ?? []) {
        if (matches(q, t.label, ...(t.keywords ?? []))) hits.push({ section: s, tab: { id: t.id, label: t.label } });
      }
    }
  }
  return hits;
}
